import { render } from "./Updates.vue?vue&type=template&id=410e3810"
import script from "./Updates.vue?vue&type=script&lang=ts"
export * from "./Updates.vue?vue&type=script&lang=ts"
script.render = render

export default script